module.exports = __webpack_public_path__ + "img/music-square-add.1cee8d0b.svg";